// extracted by mini-css-extract-plugin
export default {"getRealmScoreCTA":"BDDr3VdNaxZi06ApMg4y","details":"IocaNm_4jj_6yNGgdVkg","title":"pntH91hE6eZzSX3CXSuF","autocomplete":"LsUu81Zu4QFzeydDRGM_","note":"ydtJbFr5kfTYULiQ3be3"};